// The JSON body of an Edge Function's non-2xx answer.
//
// supabase-js `functions.invoke` turns every non-2xx answer into a
// FunctionsHttpError whose message is only "Edge Function returned a non-2xx
// status code", and keeps the fetch Response, body unread, as its `context`.
// Our functions put the reason in that body (paystack-initialize: 422
// `{ ok:false, error:"tenant_not_connected" }`), so read it from there. A
// request that never got an answer (FunctionsFetchError: its context is the
// fetch error, with no json()) has no body. The same contract as the admin's
// invokeErrorBody (apps/admin/src/lib/edge-error.ts). Pure: no client.

/** The body as an object, or null when there is none to read; never throws. */
export async function invokeErrorBody(error: unknown): Promise<Record<string, unknown> | null> {
  const context = (error as { context?: { json?: unknown } } | null | undefined)?.context;
  if (!context || typeof context.json !== "function") return null;
  try {
    const body: unknown = await (context as { json: () => Promise<unknown> }).json();
    return typeof body === "object" && body !== null && !Array.isArray(body)
      ? (body as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}
